export const HEADING_TAG = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
} as const;

export const HEADING_COLOR = {
  primary: 'primary',
  success: 'success',
  danger: 'danger',
} as const;

export const HEADING_ALIGN = {
  left: 'left',
  center: 'center',
  right: 'right',
} as const;
